<template>
  <c-modal
    :id="$getConst('NO_MONEY_MODAL_ID')"
    :padding="0"
    fluid
    overflow="hidden"
    variant="danger"
  >
    <div
      class="row"
      style="display: flex"
    >
      <div class="col-xs-6 modal-col-left">
        <div class="bg-image" />
        <div class="warning-image" />
      </div>
      <div class="col-xs-6 modal-col-right">
        <p>Внимание!</p>
        <p>Уведомляем вас о том, что на сегодняшний день от Вашей компании не поступала оплата за услуги.</p>
        <div>Просим оплатить продвижение сайта в кратчайшие сроки! Мы надеемся на дальнейшее плодотворное сотрудничество.</div>
      </div>
    </div>
  </c-modal>
</template>

<script>
import CModal from '../../../../../../../resources/js/components/ui/CModal'

// TODO: переместить в модуль Seo
export default {
  name: 'NoMoney',
  components: {
    CModal
  }
}
</script>

<style lang="scss" scoped>
@import "./resources/css/_variables.scss";

.bg-image {
  display: inline-block;
  width: 100%;
  height: 100%;
  background-image: url('../../../../../../../Modules/Seo/Resources/assets/img/accounting-documents/depositphotos.jpg');
  background-position: center;
  background-size: cover;
  filter: blur(2px);
  -webkit-filter: blur(2px);
}

.warning-image {
  background-image: url('../../../../../../../Modules/Seo/Resources/assets/img/accounting-documents/warning.png');
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}

.modal-col-left {
  padding: 0;
}

.modal-col-right {
  background-color: $textDangerColor;
  color: white;
  padding: 50px 15px;
}

.modal-col-right p {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
